import { style, styleVariants } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";

const newsHeaderTeamBase = style({
  display: "flex",
  alignItems: "center",
  gap: vars.space.xs,
});

export const newsHeaderTeamStyles = styleVariants({
  home: [newsHeaderTeamBase],
  away: [newsHeaderTeamBase, { flexDirection: "row-reverse" }],
});

export const badgeWrapper = style({
  width: "3.2rem",
  height: "3.2rem",
});

export const teamNameAbbr = style({
  selectors: {
    "&[title]": {
      textDecoration: "none",
    },
  },
});
